export type GtmEvent = {
  event: string;
  element: string;
} & Record<string, unknown>;

export function pushGtmEvent(gtmEvent: GtmEvent): void {
  globalThis?.dataLayer?.push(gtmEvent);
}
